import './styles/app-screenshot.scss';

type ProductInfoBoxProps = {
  appScreenShot: AppScreenShot
}

type AppScreenShot = {
  copy: string
  desktop_image: {
    source_url: string
  },
  mobile_image: {
    source_url: string
  },
  sub_title: string,
  title: string
}

const ProductInfoBox = ({ appScreenShot }:ProductInfoBoxProps) => (
  <section className="app-screenshot">
    <h2 className="sub-title has-text-centered-mobile">
      {appScreenShot.title}
    </h2>
    <h3 className="headline has-text-centered-mobile">
      {appScreenShot.sub_title}
    </h3>
    <p className="copy has-text-centered-mobile">{appScreenShot.copy}</p>
    <picture>
      <source
        className="scheduler-image"
        srcSet={ appScreenShot.mobile_image.source_url }
        media="(max-width: 768px)"
      />
      <img
        loading="lazy"
        className="scheduler-image"
        width="1064"
        height="606"
        src={ appScreenShot.desktop_image.source_url }
        alt="screenshot of When I Work scheduling tool"
      />
    </picture>
  </section>
);


export default ProductInfoBox;
